import Stack from "@mui/material/Stack";
import TextField from "@mui/material/TextField";
import IconButton from "@mui/material/IconButton";
import CheckIcon from "@mui/icons-material/Check";
import React, {useState} from "react";
import {s_char} from "../../_signals/s_char";
import {s_char_pr, s_char_ws} from "../../_signals/s_char_calc";
import {Item, LLabel} from "../CharStyled";
import {useSignals} from "@preact/signals-react/runtime";
import {v4} from 'uuid'
import updChar from "../../_sig_api/updChar";
import {ResultsAdd} from "../../_api/BEResult";
import {CharacterFieldUpdateField} from "../../_payload/CharacterFieldUpdateField";
import {IResult} from "../../_interfaces/IResult";
import {rollStep} from "../../_helper/rollStep";
import {s_char_attr_str_step} from "../../_signals/s_char_attr";
import {s_app_cid, s_app_rid, s_app_sl} from "../../_signals/s_app";


export default function CharPDmg() {
    useSignals()
    const [PDmg, setPDmg] = useState(0)

    const addPDmg = () => {
        if (PDmg < 1) {
            setPDmg(0);
            return;
        }
        const wundschwelle = s_char_ws.value;
        const psyR = s_char_pr.value;  // incl _mod
        const newWounds = Math.floor((PDmg - psyR) / wundschwelle); // TODO mehrere???
        // const newWounds = (addPDmg - psyR) > wundschwelle ? 1 : 0;
        const newDmg = (PDmg - psyR);
        const niederschlag = newDmg > wundschwelle + 5;
        const niederschlagVS = newDmg - wundschwelle;

        if (newDmg > 0) {
            const newSchaden = s_char.value.schaden + newDmg;
            const newWunden = s_char.value.wunden + newWounds;

            let upd: CharacterFieldUpdateField[] = [{k: 'schaden', v: newSchaden}];
            if (newWounds > 0) upd.push({k: 'wunden', v: newWunden});
            updChar(upd)

            if (niederschlag) {
                let nspstep = s_char_attr_str_step.value - s_char.value.wunden;
                let rolled = rollStep(nspstep, false, niederschlagVS);
                const result: IResult = {
                    id: v4(),
                    cid: s_app_cid.value,
                    rid: s_app_rid.value,
                    title: 'erhält Schaden ' + newDmg + ' (' + PDmg + ' - ' + psyR + ')' + (newWounds > 0 ? ' Wunden: ' + newWounds : '') + (niederschlag ? ' Niederschlag vs: ' + niederschlagVS : ''),
                    name: s_char.value.name,
                    nsc: s_char.value.nsc,
                    sl: s_app_sl.value,
                    eff: '',
                    addEff: '',
                    time: rolled.time,
                    step: rolled.step,
                    result: rolled.result,
                    rolled: rolled.rolled,
                    step_mod: 0,
                    karma: '',
                    successes: rolled.successes,
                    success: rolled.success,
                    rollas: 'nsp',
                    rollvs: niederschlagVS
                }
                ResultsAdd(result);
            }
        } else {
            alert('Kein Schaden nach Abzug der Rüstung');
        }
        setPDmg(0);
    }

    return <Item>
        <Stack direction="column">
            <LLabel>Schaden physisch</LLabel>
            <Stack direction="row"
                   justifyContent="space-between"
                   alignItems="stretch"
                   spacing={2}>
                <TextField style={{marginLeft: 8, width: "100%"}}
                           defaultValue={PDmg}
                           onChange={e => setPDmg(parseInt(e.target.value))}
                           variant="standard"
                           type="number"/>
                <IconButton style={{minWidth: "25%"}}
                            size="small"
                            onClick={addPDmg}><CheckIcon/></IconButton>
            </Stack>
        </Stack>
    </Item>;
}